import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .mySwiper", {
    spaceBetween: '2.61%',
    slidesPerView: 5,
    direction: 'vertical',
});
var swiper2 = new Swiper(".section1 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});

var swiperText = new Swiper(".section2 .swiper-text .swiper", {
    loop:true,
    freeMode: true,
    watchSlidesProgress: true,
    speed:300,
});
var swiperPic = new Swiper(".section2 .swiper-pic", {
    spaceBetween: '1.096%',
    slidesPerView: 1.878,
    centeredSlides: true,
    loop:true,
    autoplay: {
        delay: 8000,
        disableOnInteraction: false,
	},
	speed:700,
    navigation: {
        nextEl: ".section2 .swiper-button-next",
        prevEl: ".section2 .swiper-button-prev",
    },
    thumbs: {
        swiper: swiperText,
    },
});


$(".section6 ul li").eq(0).addClass("active");

$(".section6 ul li .title").click(function() {
     let $dl = $(this).parent().parent();

    if($dl.hasClass("active")){

        $dl.removeClass("active");

    }else{

        $(".section6 ul li").removeClass("active");

        $dl.addClass("active");
    }
})

$(".section6 ul li .arrow").click(function() {
     let $dl = $(this).parent();

    if($dl.hasClass("active")){

        $dl.removeClass("active");

    }else{

        $(".section6 ul li").removeClass("active");

        $dl.addClass("active");
    }
})